import { z } from 'zod';

import { unsafeCreateCastedSchema, UpdateIdsAndRemittanceDataRow } from '@willow/types-iso';

import {
  validateInvestorFields,
  ValidateInvestorFieldsOptions,
} from '../create/crossFieldParsers/validateInvestorFields';

const validateIdFields = (data: UpdateIdsAndRemittanceDataRow, ctx: z.RefinementCtx) => {
  const keys = [
    'ownerId',
    'poolId',
    'previousServicerId',
    'capitalPartnerId',
    'fullId',
    'otherId1',
    'otherId2',
    'otherId3',
    'investorName',
    'investorLoanId',
  ] as const;

  for (const key of keys) {
    // Note: excel is sometimes changing id fields to scientific format (ie 20+15243)
    if (data[key] && (data[key] as string).indexOf('+') >= 0) {
      ctx.addIssue({
        code: 'custom',
        message: 'ID contains invalid "+" character',
        path: [key],
      });
    }

    if (data[key] && !data.effectiveDate) {
      ctx.addIssue({
        code: 'custom',
        message: 'ID updates require an effective date',
        path: [key],
      });
    }
  }
};

const validateRemittanceFields = (data: UpdateIdsAndRemittanceDataRow, ctx: z.RefinementCtx) => {
  if (
    (data.investorRemittanceRate && data.servicerRemittanceRate == null) ||
    (data.investorRemittanceRate == null && data.servicerRemittanceRate)
  ) {
    ctx.addIssue({
      code: 'custom',
      message: 'Updating the remittance rate requires both an investor remittance rate and a servicer remittance rate',
      path: ['loanId'],
    });
  }

  if (data.investorRemittanceRate && data.servicerRemittanceRate && data.effectiveDate == null) {
    ctx.addIssue({
      code: 'custom',
      message: 'Updating the remittance rate requires an effective date',
      path: ['loanId'],
    });
  }
};

export const getUpdateIdsAndRemittanceCrossFieldParser = (options?: Partial<ValidateInvestorFieldsOptions>) =>
  unsafeCreateCastedSchema(UpdateIdsAndRemittanceDataRow)
    .superRefine(validateIdFields)
    .superRefine(validateRemittanceFields)
    .superRefine(validateInvestorFields({ investorReportingEnabled: options?.investorReportingEnabled ?? false }));
